export default __webpack_public_path__ + "static/media/Asset-1WarfighterWhite.45297e1f.svg";